export enum FormErrors {
  RequiredField = 'REQUIRED_FIELD',
  EmailFormat = 'EMAIL_FORMAT',
  EmailDomain = 'EMAIL_DOMAIN',
  PasswordFormat = 'PASSWORD_FORMAT',
  EmptyField = 'EMPTY_FIELD',
  PercentageFormat = 'PERCENTAGE_FORMAT',
  CarriedPercentageFormat = 'CARRIED_PERCENTAGE_FORMAT',
  PositiveFormat = 'POSITIVE_FORMAT',
  IntegerFormat = 'INTEGER_FORMAT',
  TodayFormat = 'TODAY_FORMAT',
  ValidDateFormat = 'VALID_DATE_FORMAT',
  UboPercentageFormat = 'UBO_PERCENTAGE_FORMAT',
  ValuationField = 'VALUATION_FIELD',
  SharePriceField = 'SHARE_PRICE_FIELD',
  PreferredShareCount = 'PREFERRED_SHARE_COUNT',
  UnauthorizedChar = 'UNAUTHORIZED_CHARACTER',
  FileTooLarge = 'FILE_TOO_LARGE',
  DropzoneDefault = 'DROPZONE_DEFAULT',
  InvalidFileFormat = 'INVALID_FILE_FORMAT',
  MinimalAmount = 'MINIMAL_AMOUNT',
  MaximalAmount = 'MAXIMAL_AMOUNT',
  FileRequired = 'FILE_REQUIRED',
  MinimalAmountGreaterThanMaximal = 'MINIMAL_AMOUNT_GREATER_THAN_MAXIMAL',
  MinimalAmountGreaterThanNominalValue = 'MINIMAL_AMOUNT_GREATER_THAN_NOMINAL_VALUE',
  MaximalAmountLessThanMinimal = 'MAXIMAL_AMOUNT_GREATER_LESS_THAN',
  MinimalCapitalGreaterThanMaximal = 'MINIMAL_CAPITAL_GREATER_THAN_MAXIMAL',
  MaximalCapitalLessThanMinimal = 'MAXIMAL_CAPITAL_GREATER_LESS_THAN',
  AmountGreaterThanHardCap = 'AMOUNT_GREATER_THAN_HARD_CAP',
  DropzoneInvalidTemplate = 'DROPZONE_INVALID_TEMPLATE',
  AmountGreaterThanShareCap = 'AMOUNT_GREATER_THAN_SHARE_CAP',
  AmountLowerThanShareCap = 'AMOUNT_LOWER_THAN_SHARE_CAP',
  HardCapGreaterThanNominalValue = 'HARDCAP_GREATER_THAN_NOMINAL_VALUE',
  FundsSourceCertificateMissing = 'FUNDS_SOURCE_CERTIFICATE_MISSING',
  PhoneFormat = 'PHONE_FORMAT',
  SoftGreaterThanHardCap = 'SOFTCAP_GREATER_THAN_HARDCAP',
}
